"use strict";

($dt => {

	/**
	 * This is the initial screen with topic details.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller  
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i0 = (block, inner_screen, controller) => {
		// This screen is seen if the user is logged in, but we will dynamically check they are still logged in before proceeding
		const next_button_elem = inner_screen.inner_elem.querySelector('.button-next');
		
		next_button_elem.addEventListener('click', () => {
			const { current_screen, contact_info } = block;
			if (contact_info.anon) {
				current_screen.inner = 1;
			} else {
				current_screen.inner = 2;
			}
			controller.SetScreenUI(block);
		});
	};

})(window.d3_wp_themejs);
